import katex from "katex";

/**
 * Classe responsável pelas adaptações nos métodos do katex
 */
export class KatexAdapter {
    constructor() {}

    /**
     * Renderiza fórmula para o Katex
     * @param formula Fórmula em string
     * @param element Elemento do DOM que será renderizado
     * @param configs Configurações opcionais do katex
     */
    render(
        formula: string,
        element: HTMLElement,
        configs: Record<string, any> = {}
    ): void {
        try {
            katex.render(formula, element, {
                throwOnError: false,
                fleqn: true,
                minRuleThickness: 0.06,
                ...configs
            });
        } catch (err) {}
    }
}
